/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'at.tastetest.play.state'

type $nsid = typeof $nsid

export { $nsid }

type Main = {
  $type: 'at.tastetest.play.state'
  league: string
  theme: string
  participants: l.DidString[]
  startsAt: number
  submissionEndsAt: number
  votingEndsAt: number
  phase: 'scheduled' | 'submitting' | 'voting' | 'results'
  upvotes: number
  picks: Pick$0[]
  ballots: Ballot[]
  results: Result[]
  roundNumber?: number
  history?: CompletedRound[]
  description?: string
  plannedRounds?: PlannedRound[]
  openMembership?: boolean
}

export type { Main }

const main = /*#__PURE__*/ l.record<'any', Main>(
  'any',
  $nsid,
  /*#__PURE__*/ l.object({
    league: /*#__PURE__*/ l.string(),
    theme: /*#__PURE__*/ l.string({ minGraphemes: 1, maxGraphemes: 200 }),
    participants: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.string({ format: 'did' }),
      { maxLength: 20 },
    ),
    startsAt: /*#__PURE__*/ l.integer({
      minimum: 0,
      maximum: 9007199254740991,
    }),
    submissionEndsAt: /*#__PURE__*/ l.integer({
      minimum: 0,
      maximum: 9007199254740991,
    }),
    votingEndsAt: /*#__PURE__*/ l.integer({
      minimum: 0,
      maximum: 9007199254740991,
    }),
    phase: /*#__PURE__*/ l.enum([
      'scheduled',
      'submitting',
      'voting',
      'results',
    ]),
    upvotes: /*#__PURE__*/ l.integer({ minimum: 1, maximum: 100 }),
    picks: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<Pick$0>((() => pick$0) as any),
      { maxLength: 20 },
    ),
    ballots: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<Ballot>((() => ballot) as any),
      { maxLength: 20 },
    ),
    results: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<Result>((() => result) as any),
      { maxLength: 20 },
    ),
    roundNumber: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.integer({ minimum: 1, maximum: 20 }),
    ),
    history: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<CompletedRound>((() => completedRound) as any),
        { maxLength: 19 },
      ),
    ),
    description: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxGraphemes: 1000 }),
    ),
    plannedRounds: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<PlannedRound>((() => plannedRound) as any),
        { maxLength: 19 },
      ),
    ),
    openMembership: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  }),
)

export { main }

const $type = $nsid

type $type = typeof $type

export { $type }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main)
export const $build = /*#__PURE__*/ main.build.bind(main)
export const $assert = /*#__PURE__*/ main.assert.bind(main)
export const $check = /*#__PURE__*/ main.check.bind(main)
export const $cast = /*#__PURE__*/ main.cast.bind(main)
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main)
export const $matches = /*#__PURE__*/ main.matches.bind(main)
export const $parse = /*#__PURE__*/ main.parse.bind(main)
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main)
export const $validate = /*#__PURE__*/ main.validate.bind(main)
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)

type Pick$0 = {
  $type?: 'at.tastetest.play.state#pick'
  token: string
  owner: l.DidString
  url: string
  title: string
  identity?: string
  provider?: string
  postUri?: string
  postCid?: string
}

export type { Pick$0 as Pick }

const pick$0 = /*#__PURE__*/ l.typedObject<Pick$0>(
  $nsid,
  'pick',
  /*#__PURE__*/ l.object({
    token: /*#__PURE__*/ l.string(),
    owner: /*#__PURE__*/ l.string({ format: 'did' }),
    url: /*#__PURE__*/ l.string({ maxLength: 2000 }),
    title: /*#__PURE__*/ l.string({ maxGraphemes: 200 }),
    identity: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    provider: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    postUri: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    postCid: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  }),
)

export { pick$0 as pick }

type Allocation = {
  $type?: 'at.tastetest.play.state#allocation'
  token: string
  points: number
}

export type { Allocation }

const allocation = /*#__PURE__*/ l.typedObject<Allocation>(
  $nsid,
  'allocation',
  /*#__PURE__*/ l.object({
    token: /*#__PURE__*/ l.string(),
    points: /*#__PURE__*/ l.integer({ minimum: 0, maximum: 100 }),
  }),
)

export { allocation }

type Ballot = {
  $type?: 'at.tastetest.play.state#ballot'
  voter: l.DidString
  allocations: Allocation[]
}

export type { Ballot }

const ballot = /*#__PURE__*/ l.typedObject<Ballot>(
  $nsid,
  'ballot',
  /*#__PURE__*/ l.object({
    voter: /*#__PURE__*/ l.string({ format: 'did' }),
    allocations: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<Allocation>((() => allocation) as any),
      { maxLength: 20 },
    ),
  }),
)

export { ballot }

type Result = {
  $type?: 'at.tastetest.play.state#result'
  token: string
  owner: l.DidString
  score: number
  rank: number
  penalized: boolean
}

export type { Result }

const result = /*#__PURE__*/ l.typedObject<Result>(
  $nsid,
  'result',
  /*#__PURE__*/ l.object({
    token: /*#__PURE__*/ l.string(),
    owner: /*#__PURE__*/ l.string({ format: 'did' }),
    score: /*#__PURE__*/ l.integer({ minimum: -10000, maximum: 10000 }),
    rank: /*#__PURE__*/ l.integer({ minimum: 1, maximum: 20 }),
    penalized: /*#__PURE__*/ l.boolean(),
  }),
)

export { result }

type CompletedRound = {
  $type?: 'at.tastetest.play.state#completedRound'
  league: string
  theme: string
  participants: l.DidString[]
  startsAt: number
  submissionEndsAt: number
  votingEndsAt: number
  phase: 'results'
  upvotes: number
  picks: Pick$0[]
  ballots: Ballot[]
  results: Result[]
  roundNumber: number
  description?: string
  openMembership?: boolean
}

export type { CompletedRound }

const completedRound = /*#__PURE__*/ l.typedObject<CompletedRound>(
  $nsid,
  'completedRound',
  /*#__PURE__*/ l.object({
    league: /*#__PURE__*/ l.string(),
    theme: /*#__PURE__*/ l.string({ minGraphemes: 1, maxGraphemes: 200 }),
    participants: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.string({ format: 'did' }),
      { maxLength: 20 },
    ),
    startsAt: /*#__PURE__*/ l.integer({
      minimum: 0,
      maximum: 9007199254740991,
    }),
    submissionEndsAt: /*#__PURE__*/ l.integer({
      minimum: 0,
      maximum: 9007199254740991,
    }),
    votingEndsAt: /*#__PURE__*/ l.integer({
      minimum: 0,
      maximum: 9007199254740991,
    }),
    phase: /*#__PURE__*/ l.literal('results'),
    upvotes: /*#__PURE__*/ l.integer({ minimum: 1, maximum: 100 }),
    picks: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<Pick$0>((() => pick$0) as any),
      { maxLength: 20 },
    ),
    ballots: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<Ballot>((() => ballot) as any),
      { maxLength: 20 },
    ),
    results: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<Result>((() => result) as any),
      { maxLength: 20 },
    ),
    roundNumber: /*#__PURE__*/ l.integer({ minimum: 1, maximum: 20 }),
    description: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxGraphemes: 1000 }),
    ),
    openMembership: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  }),
)

export { completedRound }

type PlannedRound = {
  $type?: 'at.tastetest.play.state#plannedRound'
  theme: string
  description?: string
  startsAt: number
  submissionEndsAt: number
  votingEndsAt: number
}

export type { PlannedRound }

const plannedRound = /*#__PURE__*/ l.typedObject<PlannedRound>(
  $nsid,
  'plannedRound',
  /*#__PURE__*/ l.object({
    theme: /*#__PURE__*/ l.string({ minGraphemes: 1, maxGraphemes: 200 }),
    description: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxGraphemes: 1000 }),
    ),
    startsAt: /*#__PURE__*/ l.integer({
      minimum: 0,
      maximum: 9007199254740991,
    }),
    submissionEndsAt: /*#__PURE__*/ l.integer({
      minimum: 0,
      maximum: 9007199254740991,
    }),
    votingEndsAt: /*#__PURE__*/ l.integer({
      minimum: 0,
      maximum: 9007199254740991,
    }),
  }),
)

export { plannedRound }
